import "../styles/ResumeStyle.css";
import resumePDF from "../assets/ResumeAssets/TC-Resume.pdf"
import billabong from "../assets/ResumeAssets/billabong-logo.png"
import yorba from "../assets/ResumeAssets/yorba-linda.png"

import golf from "../assets/ResumeAssets/roger-dunn-golf-logo.png"
import bisco from "../assets/ResumeAssets/biscologo.png"
import ebsco from "../assets/ResumeAssets/EBSCO_Industries_logo.svg.png"
import carncorp from "../assets/ResumeAssets/carn-png.png"
import cruiseautomation from "../assets/ResumeAssets/Cruise_Wordmark_Presidio.png"
import { useState } from "react";


function Resume() {
  const [floating, setFloating] = useState(false);

  // Trigger floating after slide-in finishes
  const handleAnimationEnd = () => setFloating(true);

  return (
  
    <div className="resume-page">
      
      {/* Left logos */}
      <div className="side-logos left">
        {[billabong, yorba, golf].map((logo, i) => (
          <img
            key={i}
            src={logo}
            alt={`Logo ${i+1}`}
            className={floating ? "float" : "slide-in-left"}
            onAnimationEnd={i === 0 ? handleAnimationEnd : null} 
            /* only trigger once when first logo finishes */
          />
        ))}
      </div>

      {/* Main content */}
      <div className="resume-content">
        <div className="resume-header">
          <h1>My Career Path</h1>
          <button
  className="button"
  onClick={() => {
    const link = document.createElement('a');
    link.href = resumePDF;             // path to your PDF
    link.download = "Tanner_Culley_Resume.pdf"; // filename
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }}
>
  <span className="button__text">Download</span>
  <span class="button__icon"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 35 35" id="bdd05811-e15d-428c-bb53-8661459f9307" data-name="Layer 2" class="svg"><path d="M17.5,22.131a1.249,1.249,0,0,1-1.25-1.25V2.187a1.25,1.25,0,0,1,2.5,0V20.881A1.25,1.25,0,0,1,17.5,22.131Z"></path><path d="M17.5,22.693a3.189,3.189,0,0,1-2.262-.936L8.487,15.006a1.249,1.249,0,0,1,1.767-1.767l6.751,6.751a.7.7,0,0,0,.99,0l6.751-6.751a1.25,1.25,0,0,1,1.768,1.767l-6.752,6.751A3.191,3.191,0,0,1,17.5,22.693Z"></path><path d="M31.436,34.063H3.564A3.318,3.318,0,0,1,.25,30.749V22.011a1.25,1.25,0,0,1,2.5,0v8.738a.815.815,0,0,0,.814.814H31.436a.815.815,0,0,0,.814-.814V22.011a1.25,1.25,0,1,1,2.5,0v8.738A3.318,3.318,0,0,1,31.436,34.063Z"></path></svg></span>
</button>
        </div>
        <div className="pdf-container">
          <embed src={resumePDF} type="application/pdf" className="pdf-embed" />
        </div>
      </div>

      {/* Right logos */}
      <div className="side-logos right">
        {[bisco, ebsco, cruiseautomation, carncorp].map((logo, i) => (
          <img
            key={i}
            src={logo}
            alt={`Logo ${i+5}`}
            className={floating ? "float" : "slide-in-right"}
          />
        ))}
      </div>
    </div>
  );
}

export default Resume;